import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.MobileApp1,
  LocationVarKey.MobileApp2,
  LocationVarKey.HasAfterNavigateMobileApp,
  LocationVarKey.AfterNavigateMobileApp1
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Mobile App{" "}
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.MobileApp1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.MobileApp2}
        enableSwitchVar={LocationVarKey.HasMobileApp2Enabled}
      />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasMobileApp, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.HasAfterNavigateMobileApp}
          label="Ask if they want to be navigated to your Mobile App Download URL"
        />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasAfterNavigateMobileApp, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader
            {...page}
            subheading="After navigating the customer to a new page, the chat will open and respond based on the information below."
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasAfterNavigateMobileApp, "1")}
          >
            {" "}
            After Navigate{" "}
          </SectionHeader>
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasAfterNavigateMobileApp, "1")}
            marginTop
            label=" Message 1"
            keyName={LocationVarKey.AfterNavigateMobileApp1}
          />
        </Section>
      </Section>
    </>
  );
}
